<template>
	<el-card shadow="hover">
		<div slot="header" class="clear-float">
			<span v-if="show === 1">
				<el-date-picker size="small" :key="JSON.stringify(historySearch.timeRange)"
					v-model="historySearch.timeRange"
					type="datetimerange"
					align="right"
					unlink-panels
					range-separator="至"
					start-placeholder="开始月份"
					end-placeholder="结束月份"
					:picker-options="pickerOptions">
				</el-date-picker>
				<el-button icon="el-icon-search" size="small" style="margin-left: 5px" @click="loadAsinHistory(null)"></el-button>
				<el-button style="margin-left: 15px" size="small" @click="checkTime(1)">一周</el-button>
				<el-button  size="small" @click="checkTime()">两周</el-button>
				<el-button  size="small"@click="checkTime(2)">一个月</el-button>
				<el-button  size="small" @click="checkTime(3)">全部</el-button>
			</span>

			<el-radio-group v-model="show" size="mini" style="float:right;">
				<el-radio-button :label="1">趋势图</el-radio-button>
				<el-radio-button :label="2">历史数据</el-radio-button>
			</el-radio-group>
		</div>
		<div style="height: 400px" v-loading="loading">
			<div v-show="show === 1">
				<chart-sub :data_height="400" :option="chartData" v-if="chartData"></chart-sub>
			</div>
			<div v-show="show === 2" style="height: 100%" v-loading="historyTableData.loading">
				<el-table :data="historyTableData.list" height="90%">
					<el-table-column label="追踪时间" align="center">
						<template slot-scope="scope">
							{{ $fomatTime(scope.row.createTime,'YYYY-MM-DD HH:mm:ss') }}
						</template>
					</el-table-column>
					<el-table-column label="自然排名" align="center">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.absolutePosition">{{ scope.row.absolutePosition }}</el-tag>
							<span v-else class="no-data-font"> -- </span>
						</template>
					</el-table-column>
					<el-table-column label="自然页码" align="center" width="150">
						<template slot-scope="scope">
							<font v-if="scope.row.position">
								第
								<font class="ranking-num">{{ scope.row.currentPage }}</font>
								页
								<font class="ranking-num">{{ scope.row.position }}</font> / <font class="ranking-num">{{ scope.row.currentPageSize }}</font>
							</font>
							<font v-else> - </font>
						</template>
					</el-table-column>
					<el-table-column label="广告排名" align="center">
						<template slot-scope="scope">
									<span v-if="scope.row.adAbsolutePosition">
										<el-tag type="danger">{{ scope.row.adAbsolutePosition }}</el-tag>
									</span>
							<span v-else  class="no-data-font"> -- </span>
						</template>
					</el-table-column>
					<el-table-column label="广告页码" align="center"  width="150">
						<template slot-scope="scope">
							<font v-if="scope.row.adPosition">
								第
								<font class="ad-ranking-num">{{ scope.row.adCurrentPage }}</font>
								页 <font class="ad-ranking-num">{{ scope.row.adPosition }}</font> / <font class="ad-ranking-num">{{ scope.row.adCurrentPageSize }}</font>
							</font>
							<font v-else  class="no-data-font"> -- </font>
						</template>
					</el-table-column>
				</el-table>
				<div style="text-align: center;padding-top: 15px">
					<page-sub :background="true" layout="sizes,prev, pager, next"
						:page-sizes="[5,10,20, 30, 50]"
						@current-change="historyPageChange" @size-change="historySizeChange"
						:total="historyTableData.total" :page-size="historyTableSearch.pageSize"
						:current-page="historyTableSearch.page"/>
				</div>
			</div>
		</div>
	</el-card>
</template>

<script>
import COPY_SUB from "@/components/template/otherSub/copySub";
import Chart from "@/components/template/otherSub/hightChartSub";
import PAGE_SUB from "@/components/template/otherSub/pageSub";
import { api_asinDataPage_monitoring2, api_asinRankTrends_monitoring2 } from "@/components/api/keywordsMonitoring2";
import { formatMonitoringPositionData } from "@/components/config/chart/asinKeyword";

export default {
	name: "asinRankTrendsSub",
	inject: ['WINDOW', 'F_alertMsg', 'F_windowLoading', 'F_getErrMSg', 'F_LOGIN', 'LOGINUSER'],
	data() {
		return {
			windowObj: this.WINDOW,
			loginUser: this.LOGINUSER,
			loading : false,
			pickerOptions: {
				shortcuts: [{
					text: '本月',
					onClick(picker) {
						picker.$emit('pick', [new Date(), new Date()]);
					}
				}, {
					text: '今年至今',
					onClick(picker) {
						const end = new Date();
						const start = new Date(new Date().getFullYear(), 0);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近六个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setMonth(start.getMonth() - 6);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
			lastTime : null,
			chartData : null,
			historySearch : {
				asinTaskId : null,
				timeRange : [null,null],
			},
			historyTableSearch : {
				asinTaskId : null,
				page : 1,
				pageSize: 20,
			},
			historyTableData : {
				loading : false
			},
			show : 1,
		};
	},
	props : {
		asinTaskId : {
			required : true
		},

	},
	components : {
		'copy-sub' : COPY_SUB,
		'chart-sub': Chart,
		'page-sub': PAGE_SUB,
	},
	created() {
		this.$data.historySearch.asinTaskId = this.asinTaskId
		this.$data.historyTableSearch.asinTaskId = this.asinTaskId
		this.$options.methods.loadAsinHistory(this)
	},
	methods: {
		checkTime : function(type) {
			let  lastTime  = new Date(this.$data.lastTime)
			if (type === 1){
				this.$data.historySearch.timeRange[0] = new Date(lastTime.setDate(lastTime.getDate() - 7))
			}else if (type === 2){
				this.$data.historySearch.timeRange[0] = new Date(lastTime.setMonth(lastTime.getMonth() - 1))
			}else if(type === 3){
				this.$data.historySearch.timeRange[0] = new Date('2020-01-01')
			}else{
				this.$data.historySearch.timeRange[0] = new Date(lastTime.setDate(lastTime.getDate() - 14))
			}
			this.$options.methods.loadAsinHistory(this)
		},
		loadAsinHistory : function(this_) {
			this_ = this_ || this
			let obj = { ...this_.$data.historySearch }
			if (obj.timeRange && obj.timeRange.length > 0){
				obj.startTime = obj.timeRange[0]
				obj.endTime = obj.timeRange[1]
				delete obj.timeRange
			}
			// 开启加载遮罩
			this_.$data.loading = true
			api_asinRankTrends_monitoring2(obj).then(res => {
				if (res.data && res.data.length > 0){
					if (!this_.$data.historySearch.timeRange[0]){
						this_.$data.historySearch.timeRange[0] = new Date(res.data[0].createTime)
					}
					if (!this_.$data.lastTime){
						let date = new Date(res.data[ res.data.length - 1 ].createTime || new Date(new Date().setDate(new Date().getDate() + 1)))
						this_.$data.historySearch.timeRange[1] = date
						this_.$data.lastTime = date
					}
				}
				this_.$data.chartData = formatMonitoringPositionData(res.data)
				console.log(this_.$data.chartData)
				//关闭遮罩
				this_.$data.loading = false
			}).catch(err => {
				console.error(err)
				//关闭遮罩
				this_.$data.loading = false
				this_.F_alertMsg(this_.F_getErrMSg(err, '加载失败'), 4)
			})
		},
		loadHistoryPage : function(this_) {
			this_ = this_ || this
			if (this_.$data.historyTableData.loading) {
				return
			}
			this_.$data.historyTableData.loading = true
			api_asinDataPage_monitoring2(this_.$data.historyTableSearch).then(res => {
				//关闭遮罩
				this_.$data.historyTableData.loading = false
				this_.$data.historyTableData = {...this_.$data.historyTableData,...res.data}
			}).catch(err => {
				console.error(err)
				//关闭遮罩
				this_.$data.historyTableData.loading = false
				this_.F_alertMsg(this_.F_getErrMSg(err, '加载失败'), 4)
			})
		},
		historySizeChange : function(val) {
			this.$data.historyTableSearch.pageSize = val
			this.$options.methods.loadHistoryPage(this)
		},
		historyPageChange : function(val) {
			this.$data.historyTableSearch.page = val
			this.$options.methods.loadHistoryPage(this)
		},
	}, watch: {
		windowObj: {
			handler() {
			},
			deep: true
		},
		loginUser: {
			handler() {
			},
			deep: true
		},
		'historySearch.timeRange' : {
			handler(v) {
				if (!v){
					this.$data.historySearch.timeRange = [undefined,this.$data.lastTime]
				}
			},
			deep: true
		},
		show : {
			handler(val) {
				if (val === 2 && !this.$data.historyTableData.list){
					this.$options.methods.loadHistoryPage(this)
				}
			},
			deep: true
		}
	}
}
</script>

<style scoped>

</style>